import { RootState } from "state/appStore";
import { useSelector } from "react-redux";
import { INotificationState } from "dataModels/stateModels/notification";

const useNotification = ():INotificationState=>{
    const notification = useSelector((state:RootState):INotificationState=>{
        return state.notification;
    });
    return notification;
}
export default useNotification;